/*
 * TWD Size Dropdown
 * Refactored 2026-07-29.
 *
 * Centralizes unavailable-option styling for product, Quick View,
 * collection cards and Choose Option dropdowns.
 */
(function () {
  if (window.TWDSizeDropdown) return;

  const api = {
    sync(select, showSelected = true) {
      if (!select) return;

      Array.from(select.options).forEach((option) => {
        if (option.dataset.optionValueId) option.textContent = option.value;
        const unavailable = option.dataset.available === "false";
        option.classList.toggle("variant-option-unavailable", unavailable);
        option.toggleAttribute("data-unavailable", unavailable);
        option.style.color = unavailable ? "#999" : "";
        option.style.textDecoration = unavailable ? "line-through" : "";
      });

      const selectedOption = select.options[select.selectedIndex];
      const selectedUnavailable =
        showSelected && selectedOption?.dataset.available === "false";
      select.style.color = selectedUnavailable ? "#999" : "";
      select.style.textDecoration = selectedUnavailable ? "line-through" : "";
    },

    bind(select) {
      if (!select) return;
      api.sync(select);
      if (select.dataset.twdSizeDropdownBound === "true") return;

      select.dataset.twdSizeDropdownBound = "true";
      select.addEventListener("pointerdown", () => api.sync(select, false));
      select.addEventListener("keydown", (event) => {
        if ([" ", "Enter", "ArrowDown", "ArrowUp"].includes(event.key)) {
          api.sync(select, false);
        }
      });
      select.addEventListener("change", () => api.sync(select));
      select.addEventListener("blur", () => api.sync(select));
    },

    copyOptionState(destination, source) {
      if (!destination || !source) return;
      const unavailable = source.dataset.available === "false";
      destination.selected = source.selected;
      destination.textContent = source.value;
      destination.dataset.available = source.dataset.available || "";
      destination.classList.toggle("variant-option-unavailable", unavailable);
      destination.toggleAttribute("data-unavailable", unavailable);
      destination.style.color = unavailable ? "#999" : "";
      destination.style.textDecoration = unavailable ? "line-through" : "";
    },

    bindAll(root = document) {
      root.querySelectorAll("select").forEach((select) => api.bind(select));
    },
  };

  window.TWDSizeDropdown = api;
})();
